/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Search } from '@coursera/cds-core';

import { useSearchContext } from 'bundles/grading/components/staff-graded-assignments/left-panel/search-and-filters/SearchContext';

import _t from 'i18n!nls/grading';

const styles = {
  container: () => css`
    display: inline-block;
    margin-right: var(--cds-spacing-100);
  `,
};

const SearchControl = ({ isTeamAssignment }: { isTeamAssignment: boolean }) => {
  const searchContext = useSearchContext();

  const teamPlaceholder = _t('Enter team name');
  const individualPlaceholder = _t('Enter learner name');
  return (
    <div css={styles.container}>
      <Search
        hideSearchButton
        value={searchContext.searchKeyword}
        onChange={searchContext.setSearchKeyword}
        placeholder={isTeamAssignment ? teamPlaceholder : individualPlaceholder}
      />
    </div>
  );
};

export default SearchControl;
